module.exports = __webpack_public_path__ + "img/DaSo.a344ac0a.jpg";